import React, { useContext } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import InstantConsult from "./pages/InstantConsult";
import BookingTimeLine from "./pages/BookingTimeLine";
import Payment from "./pages/Payment";
import MyBooking from "./pages/MyBooking";
import Diet from "./pages/Diet";
import DietPlanDetail from "./pages/Diet/DietPlanDetail";
import SelectDevice from "./pages/Diet/SelectDevice";
import PaymentSuccess from "./pages/Diet/PaymentSuccess";
// import Assessment from './pages/Diet/Assessment';
// import PlanType from './pages/Diet/Assessment/PlanType';
// import DietPlanAnalyzing from './pages/Diet/Assessment/DietPlanAnalyzing';
import RiskAssessment from "./pages/RiskAssessment";
import RiskAssessmentList from "./pages/RiskAssessment/RiskAssessmentList";
import YourScore from "./pages/RiskAssessment/YourScore";
import YourResult from "./pages/RiskAssessment/YourResult";
import Questions from "./pages/RiskAssessment/Questions";
import Ghost from "./pages/Ghost";
import Measure from "./pages/RiskAssessment/Measure";
import DietPlan from "./pages/DietPlan";
import DietPayment from "./pages/DietPlan/DietPayment";
import DietPlanSuccess from "./pages/DietPlan/DietPlanSuccess";

import DietAssessment from "./pages/DietPlan/Assessment";
import DietPlanMain from "./pages/DietPlan/DietPlanMain";
import DietPlanType from "./pages/DietPlan/Assessment/PlanType";
import DietPlanAnalyzing from "./pages/DietPlan/Assessment/DietPlanAnalyzing";
import DietPlanAI from "./pages/DietPlan/DietPlanAI";
import PaidQuestion from "./pages/DietPlan/PaidQuestion";
import CodeActivation from "./pages/DietPlan/CodeActivation";
import InfoScreen from "./pages/DietPlan/CodeActivation/InfoScreen";

// import DPDietPlan from './pages/DietPlans';
import PlanDetail from "./pages/DietPlan/PlanDetail";
import MandatoryInfo from "./pages/DietPlan/Assessment/MandatoryInfo";
import DietPlanWaitingScreen from "./pages/DietPlan/DietPlanSuccess/DietPlanWaitingScreen";
import { AppContext } from "./context/app-context";

const RoutesJs = () => {
  const [state] = useContext(AppContext);
  return (
    <BrowserRouter>
      <Routes>
        <Route index path="/" element={<InstantConsult />} />
        <Route path="/payment" element={<Payment />} />
        <Route
          path="/bookingTimeLine/:consultationId"
          element={<BookingTimeLine />}
        />
        <Route path="/myBooking" element={<MyBooking />} />
        <Route path="/diet" element={<Diet />} />
        <Route path="/diet/:type" element={<DietPlanDetail />} />
        <Route path="/diet/:type/selectDevice" element={<SelectDevice />} />
        <Route path="/diet/done" element={<PaymentSuccess />} />

        <Route path="/riskAssessment" element={<RiskAssessment />} />
        <Route path="/riskAssessment/list" element={<RiskAssessmentList />} />
        <Route path="/riskAssessment/yourScore" element={<YourScore />} />
        <Route path="/riskAssessment/yourResult" element={<YourResult />} />
        <Route
          path="/riskAssessment/question/:questionType"
          element={<Questions />}
        />
        <Route path="/riskAssessment/measure" element={<Measure />} />
        <Route path="/Ghost/:postId" element={<Ghost />} />

        <Route path="/dietPlan" element={<DietPlan />} />
        <Route path="/dietPlan/main" element={<DietPlanMain />} />
        <Route path="/dietPlan/:dietPlanId/payment" element={<DietPayment />} />
        <Route path="/dietPlan/payment" element={<DietPayment />} />
        <Route
          path="/dietPlan/:dietPlanId/payment/:isItUpgrade"
          element={<DietPayment />}
        />
        <Route path="/dietPlan/success" element={<DietPlanSuccess />} />
        <Route path="/dietPlan/analyzing" element={<DietPlanWaitingScreen />} />
        <Route path="/dietPlan/mandatory" element={<MandatoryInfo />} />
        <Route path="/dietPlan/healthConditions" element={<DietAssessment />} />
        <Route path="/dietPlan/planType" element={<DietPlanType />} />
        <Route path="/dietPlan/dietaryPreference" element={<DietPlanType />} />
        <Route path="/dietPlan/preferredCuisine" element={<DietPlanType />} />
        <Route path="/dietPlan/allergies" element={<DietPlanType />} />
        <Route path="/dietPlan/address" element={<DietPlanType />} />
        <Route
          path="/dietPlan/dietPlanAnalyzing/:dietPlanId"
          element={<DietPlanAnalyzing />}
        />
        <Route path="/dietPlan/ai" element={<DietPlanAI />} />

        <Route
          path="/dietPlan/paidQuestion/:dietPlanId"
          element={<PaidQuestion />}
        />
        <Route
          path="/dietPlan/couponCodeActivation"
          element={<CodeActivation />}
        />
        <Route path="/dietPlan/infoScreen/:active" element={<InfoScreen />} />
        <Route path="/dietPlan/infoScreen" element={<InfoScreen />} />

        <Route path="/dietPlan/:categoryId" element={<PlanDetail />} />
        <Route
          path="/dietPlan/:categoryId/:dietPlanId"
          element={<PlanDetail />}
        />
      </Routes>
    </BrowserRouter>
  );
};

export default RoutesJs;
